import { DirectionsRepository } from '../repositories/directions.repository'
import {
    CreateCompanyDirectionPayload,
    DirectionsCreateDirectionResponseT,
    DirectionsCreatePayloadT,
    DirectionsGetCitiesForDirectionsResponseT,
    DirectionsGetListParamsT,
    DirectionsGetListResponseT,
    DirectionsUpdateDirectionResponseT,
    GetCompanyDirectionDetailsResponse,
    GetCompanyDirectionsListResponse,
    GetCompanyDirectionsParams,
    UpdateCompanyDirectionPayload,
} from '../types/directions.types'

const directionsRepository = new DirectionsRepository()

export class DirectionsService {
    async getList(params: DirectionsGetListParamsT): Promise<DirectionsGetListResponseT> {
        const response = await directionsRepository.getList(params)
        return response.data
    }

    async createDirection(
        payload: DirectionsCreatePayloadT
    ): Promise<DirectionsCreateDirectionResponseT> {
        const response = await directionsRepository.createDirection(payload)
        return response.data
    }

    async updateDirection(
        direction_id: number,
        zoneId: number,
        isNearbyCities: number
    ): Promise<DirectionsUpdateDirectionResponseT> {
        const response = await directionsRepository.updateDirection(
            direction_id,
            zoneId,
            isNearbyCities
        )
        return response.data
    }

    async getCitiesForDirections(): Promise<DirectionsGetCitiesForDirectionsResponseT> {
        const response = await directionsRepository.getCitiesForDirections()
        return response.data
    }

    async importFromExcel(form_data: FormData): Promise<void> {
        const response = await directionsRepository.importFromExcel(form_data)
        return response.data
    }

    async deleteDirection(id: number): Promise<void> {
        const response = await directionsRepository.deleteDirection(id)
        return response.data
    }

    async getCompanyDirections(params: GetCompanyDirectionsParams): Promise<GetCompanyDirectionsListResponse> {
        const response = await directionsRepository.getCompanyDirections(params)
        return response.data
    }

    async getCompanyDirectionDetails(companyDirectionId: number): Promise<GetCompanyDirectionDetailsResponse> {
        const response = await directionsRepository.getCompanyDirectionDetails(companyDirectionId)
        return response.data
    }

    async createCompanyDirection(payload: CreateCompanyDirectionPayload): Promise<void> {
        const response = await directionsRepository.createCompanyDirection(payload)
        return response.data
    }

    async updateCompanyDirection(companyDirectionId: number, payload: UpdateCompanyDirectionPayload): Promise<void> {
        const response = await directionsRepository.updateCompanyDirection(companyDirectionId, payload)
        return response.data
    }

    async deleteCompanyDirection(companyDirectionId: number): Promise<void> {
        const response = await directionsRepository.deleteCompanyDirection(companyDirectionId)
        return response.data
    }
}
